/**
 *
 * Asynchronously loads the component for AddDebtForm
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AddDebtForm = lazyLoad(
  () => import('./index'),
  module => module.AddDebtForm,
);
